import React, { useState, useEffect, useCallback, useRef } from "react";
import { Button, Table, Modal } from "react-bootstrap";
import "./../../css/attendeeMapping.css";
import { getPassCode, checkApiError } from "../../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const MappedCABAttendeeList = ({
  eventId,
  isAddAttendee,
  setIsAddAttendee,
  showLoading,
  setisRemoveAttendee,
}) => {
  const navigate = useNavigate();
  const [mappedCABAttendeesPerPage, setMappedCABAttendeesPerPage] = useState(5);
  const [isSeletAllSelected, setIsSeletAllSelected] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [mappedCABAttendees, setMappedCABAttendees] = useState([]);
  const [mappedCABAttendeesCurrentPage, setMappedCABAttendeesCurrentPage] =
    useState(1);
  const mappedCABAttendeesPaginate = (pageNumber) =>
    setMappedCABAttendeesCurrentPage(pageNumber);
  const [mappedCABAttendeesSelectedUser, setMappedCABAttendeesSelectedUser] =
    useState([]);
  const mappedCABAttendeesIndexOfLastUser =
    mappedCABAttendeesCurrentPage * mappedCABAttendeesPerPage;
  const mappedCABAttendeesIndexOfFirstUser =
    mappedCABAttendeesIndexOfLastUser - mappedCABAttendeesPerPage;
  const [sortConfig, setSortConfig] = useState({
    key: "organization",
    direction: "asc",
  });

  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  // const dragImageRef = useRef(null);

  const handleMappedCABAttendeeSelection = (userId, event) => {
    let selectedUsers = null;
    if (event.target.checked) {
      selectedUsers = mappedCABAttendees.find((user) => user.userId === userId);
      selectedUsers.isSelected = true;
      setMappedCABAttendeesSelectedUser([
        selectedUsers,
        ...mappedCABAttendeesSelectedUser,
      ]);
    } else {
      setMappedCABAttendeesSelectedUser(
        mappedCABAttendeesSelectedUser.filter((user) => {
          if (user.userId === userId) {
            user.isSelected = false;
          }
          return user.userId !== userId;
        })
      );
    }
  };

  useEffect(() => {
    isAddAttendee && getCABAttendeeList();
  }, [isAddAttendee]);

  const resetAttendees = () => {
    let resetAttendees = mappedCABAttendees.map((item) => ({
      ...item,
      isSelected: false,
    }));
    setMappedCABAttendees(resetAttendees);
    setIsSeletAllSelected(false);
    setMappedCABAttendeesSelectedUser([]);
  };

  useEffect(() => {
    resetAttendees();
  }, [mappedCABAttendeesCurrentPage]);

  const getCABAttendeeList = useCallback(async () => {
    try {
      showLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AttendanceMapping/GetAttendeesByEventIdandFlag?encoramemberflag=false&EventId=${eventId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
        }
      );

      if(checkApiError(response.status)){ navigate("/login"); return; }

      if (response.ok) {
        const data = await response.json();
        if (data.statusCode === 200) {
          let response = data.attendanceMappingDetails.map((item, i) => {
            return { ...item, seqenceNumber: i + 1 };
          });
          setMappedCABAttendees(response);
          setIsAddAttendee(false);
        }
      } else {
        console.error(
          "Error, Get all Mapped CAB attendee List:",
          response.status
        );
        setIsAddAttendee(false);
      }
    } catch (error) {
      console.error("Error, Get all Mapped CAB attendee List:", error);
    } finally {
      showLoading(false);
    }
  }, []);

  useEffect(() => {
    getCABAttendeeList();
  }, []);

  const handlemappedCABAttendeeCurrentPageCount = (e) => {
    if (e.target.value === "" || parseInt(e.target.value) === 0) {
      setMappedCABAttendeesCurrentPage(1);
    } else if (parseInt(e.target.value) > mappedCABTotalPages) {
      setMappedCABAttendeesCurrentPage(mappedCABTotalPages);
    } else {
      setMappedCABAttendeesCurrentPage(parseInt(e.target.value));
    }
  };

  const mappedCABFilteredAttendees = mappedCABAttendees.filter((user) => {
    return Object.values(user).some(
      (value) =>
        value && value.toString().toLowerCase().includes("".toLowerCase())
    );
  });

  const currentmappedCABAttendees = mappedCABFilteredAttendees.slice(
    mappedCABAttendeesIndexOfFirstUser,
    mappedCABAttendeesIndexOfLastUser
  );

  const mappedCABTotalPages = Math.ceil(
    mappedCABFilteredAttendees.length / mappedCABAttendeesPerPage
  );

  const renderCustomPaginationItems = () => {
    let items = [];
    //previous
    items.push(
      <button
        type="button"
        className="pg-btn pg-prev-btn"
        disabled={mappedCABAttendeesCurrentPage === 1}
        onClick={() =>
          mappedCABAttendeesPaginate(mappedCABAttendeesCurrentPage - 1)
        }
      >
        &nbsp;&nbsp;
      </button>
    );
    // Always show first page
    items.push(
      <button
        type="button"
        className="pg-btn"
        disabled={mappedCABAttendeesCurrentPage === 1}
        onClick={() => mappedCABAttendeesPaginate(1)}
      >
        1
      </button>
    );
    // Always show the second page
    if (mappedCABTotalPages > 1 && mappedCABAttendeesCurrentPage < 3) {
      items.push(
        <button
          type="button"
          className="pg-btn"
          disabled={mappedCABAttendeesCurrentPage === 2}
          onClick={() => mappedCABAttendeesPaginate(2)}
        >
          2
        </button>
      );
    }

    // Always show the current page.  Put a conditional around this to prevent duplicates.
    if (
      mappedCABAttendeesCurrentPage !== 1 &&
      mappedCABAttendeesCurrentPage !== 2 &&
      mappedCABAttendeesCurrentPage !== mappedCABTotalPages
    ) {
      items.push(
        <button
          type="button"
          className="pg-btn"
          disabled={mappedCABAttendeesCurrentPage !== mappedCABTotalPages}
          onClick={() =>
            mappedCABAttendeesPaginate(mappedCABAttendeesCurrentPage)
          }
        >
          {mappedCABAttendeesCurrentPage}
        </button>
      );
    }

    // Show ellipsis if there are more pages between 2 and last
    if (mappedCABTotalPages > 2) {
      items.push(
        <button type="button" className="pg-btn pg-eclipses-btn" disabled>
          &#8230;
        </button>
      );
    }

    // Always show last page if there is more than one page
    if (mappedCABTotalPages > 1 && items.length - 1 !== mappedCABTotalPages) {
      items.push(
        <button
          type="button"
          className="pg-btn"
          disabled={mappedCABAttendeesCurrentPage === mappedCABTotalPages}
          onClick={() => mappedCABAttendeesPaginate(mappedCABTotalPages)}
        >
          {mappedCABTotalPages}
        </button>
      );
    }
    // Next
    items.push(
      <button
        type="button"
        className="pg-btn pg-next-btn"
        disabled={mappedCABAttendeesCurrentPage === mappedCABTotalPages}
        onClick={() =>
          mappedCABAttendeesPaginate(mappedCABAttendeesCurrentPage + 1)
        }
      >
        &nbsp;&nbsp;
      </button>
    );

    return items;
  };

  const handleMappedCABAttendeesPaginateShowCount = (e) => {
    if (e.target.value === "" || parseInt(e.target.value) === 0) {
      setMappedCABAttendeesPerPage(0);
      setMappedCABAttendeesCurrentPage(1);
      return;
    }
    const value =
      e.target.value >= mappedCABAttendees.length
        ? mappedCABAttendees.length
        : e.target.value;
    value < 0
      ? setMappedCABAttendeesPerPage(0)
      : setMappedCABAttendeesPerPage(value);
  };

  const handleDragStart = (event, index) => {
    dragItem.current = index;
    event.dataTransfer.effectAllowed = "move";

    // Create a custom drag image
    // const row = event.target.closest("tr");
    // const clone = row.cloneNode(true);
    // clone.style.position = "absolute";
    // clone.style.top = "-999px"; // Hide it offscreen
    // clone.style.width = `${row.offsetWidth}px`;
    // clone.style.height = `${row.offsetHeight}px`;
    // clone.style.background = window.getComputedStyle(row).backgroundColor;
    // clone.style.border = window.getComputedStyle(row).border;
    // clone.style.display = "table";

    // document.body.appendChild(clone);
    // event.dataTransfer.setDragImage(clone, 0, 0);
    // dragImageRef.current = clone;

    // setTimeout(() => row.classList.add("dragging"), 0);
  };

  const handleDragOver = (event) => {
    event.preventDefault(); // Required to allow dropping
  };

  const handleDragEnter = (index) => {
    dragOverItem.current = index;
  };

  const handleDrop = async () => {
    const updatedRows = [...mappedCABAttendees];
    const draggedItemContent = updatedRows[dragItem.current];

    updatedRows.splice(dragItem.current, 1);
    updatedRows.splice(dragOverItem.current, 0, draggedItemContent);

    dragItem.current = null;
    dragOverItem.current = null;

    const arr = [];
    updatedRows.map((item, index) => {
      return arr.push({
        attendeeMappingId: item.attendeeMappingId,
        eventId: eventId,
        userId: item.userId,
        encoraMemberFlag: false,
        seqenceNumber: index + 1,
        createdById: item.createdById,
        dateCreated: item.dateCreated,
        lastModifiedById: item.lastModifiedById,
        lastModifiedDate: item.lastModifiedDate,
      });
    });

    try {
      showLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AttendanceMapping/insertupdateAttendeemapping`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
          body: JSON.stringify({ attendeeMappings: arr }),
        }
      );

      if(checkApiError(response.status)){ navigate("/login"); return; }

      if (response.ok) {
        getCABAttendeeList();
        toast.success("CAB Attendee List Updated Successfully");
      } else {
        console.error(
          "Error, Drag & Drop Mapped CAB Attendee:",
          response.status
        );
        toast.error("CAB Attendee List Failed to Update");
      }
    } catch (error) {
      console.error("Error, Drag & Drop Mapped CAB Encora Attendee:", error);
      toast.error("CAB Attendee List Failed to Update");
    } finally {
      showLoading(false);
    }
  };

  // Function for Delete Confirmation modal
  const handleDeleteAttendee = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  //Function for Delete Confirmation
  const handleConfirmDelete = async () => {
    let selectedIds = mappedCABAttendeesSelectedUser.map(
      (item) => item.attendeeMappingId
    );

    try {
      showLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/AttendanceMapping/deleteeventattendee`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
          body: JSON.stringify(selectedIds),
        }
      );

      if(checkApiError(response.status)){ navigate("/login"); return; }

      if (response.ok) {
        getCABAttendeeList();
        setisRemoveAttendee(true);
        toast.success("CAB Attendee Record Deleted Successfully");
      } else {
        console.error(
          "Error, Delete Mapped CAB attendee List:",
          response.status
        );
        toast.error("CAB Attendee Record Failed to Delete");
      }
    } catch (error) {
      console.error("Error, Delete Mapped CAB attendee List:", error);
      toast.error("CAB Attendee Record Failed to Delete");
    } finally {
      showLoading(false);
    }

    setShowDeleteModal(false);
    resetAttendees();
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    resetAttendees();
  };

  const handleSelectAll = (event) => {
    let updatedArr = [];
    let startIndex =
      Number(mappedCABAttendeesPerPage) *
      (Number(mappedCABAttendeesCurrentPage) - 1);
    let endIndex =
      Number(mappedCABAttendeesPerPage) *
        Number(mappedCABAttendeesCurrentPage) -
      1;
    setIsSeletAllSelected(event.target.checked);
    if (event.target.checked) {
      updatedArr = mappedCABAttendees.map((obj, index) =>
        index >= startIndex && index <= endIndex
          ? { ...obj, isSelected: true }
          : obj
      );
      setMappedCABAttendees(updatedArr);
      setMappedCABAttendeesSelectedUser(
        updatedArr.filter((item) => item.isSelected)
      );
    } else {
      updatedArr = mappedCABAttendees.map((obj, index) =>
        index >= startIndex && index <= endIndex
          ? { ...obj, isSelected: false }
          : obj
      );
      setMappedCABAttendees(updatedArr);
      setMappedCABAttendeesSelectedUser([]);
    }
  };

  const requestSort = () => {
    setSortConfig({
      ...sortConfig,
      direction: sortConfig.direction === "asc" ? "desc" : "asc",
    });
    const sortedAttendees = [...mappedCABFilteredAttendees].sort((a, b) => {
      if (sortConfig.key === null) {
        return 0; // No sorting
      }

      const valueA = a[sortConfig.key]
        ? a[sortConfig.key].toString().toLowerCase()
        : "";
      const valueB = b[sortConfig.key]
        ? b[sortConfig.key].toString().toLowerCase()
        : "";

      if (valueA < valueB) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setMappedCABAttendees(sortedAttendees);
  };

  const showOutOfEntries = () => {
    const startEntry = mappedCABAttendeesPerPage === 0 || mappedCABAttendees.length === 0 ? 0 : (mappedCABAttendeesCurrentPage - 1) * mappedCABAttendeesPerPage + 1;
    const endEntry = Math.min(mappedCABAttendeesCurrentPage * mappedCABAttendeesPerPage, mappedCABAttendees.length);
    
    return (
        <>
        Showing <span className='color-black roboto-bold'>{startEntry}-{endEntry}</span> out of <span className='color-black roboto-bold'>{mappedCABAttendees.length}</span> Entries
        </>
    );
  };

  return (
    <div className="row mt-4">
      <div className="col-12">
        <div className="card">
          <div className="card-body p-0">
            <div className="d-flex justify-content-between align-items-sm-center align-items-start p-4 pb-3 flex-column flex-sm-row">
              <p className="fw-500 m-sm-0 s-h mb-3">Mapped CAB Attendee List</p>
              <div className="action-btn-container">
                <div className="d-flex justify-content-start justify-content-sm-end align-items-center color-gray flex-wrap">
                  <Button
                    variant="danger"
                    onClick={() => handleDeleteAttendee(null)}
                    className="me-3"
                    disabled={mappedCABAttendeesSelectedUser.length === 0}
                  >
                    Remove Attendee
                  </Button>

                  <div
                    className="d-flex justify-content-center align-items-center ms-2"
                    style={{ width: "140px" }}
                  >
                    Show{" "}
                    <input
                      className="form-control ms-2 me-2 text-center input-sm"
                      type="number"
                      value={mappedCABAttendeesPerPage}
                      onChange={handleMappedCABAttendeesPaginateShowCount}
                      style={{
                        width: "45px", padding: "0.4rem 0.75rem"
                      }}
                    />{" "}
                    Entries
                  </div>
                </div>
              </div>
            </div>

            <Table responsive className="map-cab-attendee attendeeTable">
              <thead className="table-light">
                <tr>
                  <th
                    scope="col"
                    className="mw-50 text-center"
                    style={{ width: "50px" }}
                  ></th>
                  <th
                    scope="col"
                    className="mw-50 text-center"
                    style={{ width: "50px" }}
                  >
                    {mappedCABAttendees.length > 0 && (
                      <input
                        type="checkbox"
                        name="attendee"
                        checked={isSeletAllSelected}
                        className="icons icon-check CABAttenteeCheckAll"
                        onChange={(e) => handleSelectAll(e)}
                      />
                    )}{" "}
                  </th>
                  <th
                    scope="col"
                    className="text-center mw-50"
                    style={{ width: "50px" }}
                  >
                    #
                  </th>
                  <th scope="col" className="mw-120">
                    First Name
                  </th>
                  <th scope="col" className="mw-120">
                    Last Name
                  </th>
                  <th scope="col" className="mw-120">
                    Designation
                  </th>
                  <th
                    scope="col"
                    className="mw-120"
                    onClick={() => requestSort()}
                    style={{ cursor: "pointer" }}
                  >
                    Organization
                    {sortConfig.key === "organization" && (
                      <span
                        className={`positiion-relative ms-1 icons icon-sort ${
                          sortConfig.direction === "asc"
                            ? "icon-sort-asc"
                            : "icon-sort-desc"
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-expand position-absolute"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708m0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708" />
                        </svg>
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentmappedCABAttendees.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No attendees found.
                    </td>
                  </tr>
                ) : (
                  currentmappedCABAttendees.map((user, index) => (
                    <tr
                      key={user.userId}
                      className="draggable"
                      onDragEnter={() => handleDragEnter(index)}
                      onDragEnd={handleDrop}
                      onDragOver={handleDragOver}
                    >
                      {currentmappedCABAttendees.length > 1 ? (
                        <td
                          className="text-center drag-handle"
                          draggable
                          onDragStart={(event) => handleDragStart(event, index)}
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              fill="currentColor"
                              className="bi bi-grip-vertical"
                              viewBox="0 0 16 16"
                            >
                              <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                            </svg>
                          </span>
                        </td>
                      ) : (
                        <td> </td>
                      )}
                      <td>
                        <input
                          type="checkbox"
                          name="attendee"
                          checked={user.isSelected}
                          className="btn-checkbox icons icon-check icon-checkbox mappedCABAttendeeSelection"
                          onChange={(e) =>
                            handleMappedCABAttendeeSelection(user.userId, e)
                          }
                        />
                      </td>
                      <td className="text-center">{user.seqenceNumber}</td>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.designation}</td>
                      <td>{user.organization}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>

            {/* Pagination for the filtered attendees */}
            <div className="d-flex justify-content-between align-items-sm-center align-items-start ps-4 pe-4 mb-3 mt-1 flex-column flex-sm-row color-gray">
              <div className="m-sm-0 mb-3">{showOutOfEntries()}
              </div>
              <div className="d-flex align-items-center flex-wrap">
                {false && <div className="d-flex justify-content-center align-items-center me-3 hide">
                  Page
                  <input
                    className="form-control ms-2 me-2 text-center input-sm"
                    type="number"
                    disabled={
                      mappedCABAttendeesPerPage >=
                      currentmappedCABAttendees.length
                    }
                    value={mappedCABAttendeesCurrentPage}
                    onChange={handlemappedCABAttendeeCurrentPageCount}
                    style={{ width: "45px", padding: "0.4rem 0.75rem" }}
                  />{" "}
                  Entries
                </div>}
                {mappedCABAttendeesPerPage > 0 && (
                  <div className="custom-paginaton">
                    {renderCustomPaginationItems()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to remove the "<spna className="fw-bold">
          {mappedCABAttendeesSelectedUser &&
            mappedCABAttendeesSelectedUser.map(
              (item, index) =>
                (index ? ", " : "") + item.firstName + " " + item.lastName
            )}
          </spna>" from Mapped CAB Attendee List?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="purple" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MappedCABAttendeeList;
